import { TERMS_OF_SERVICE_AND_PRIVACY_POLICY_URL } from "@shared/utils/constants";

export const dashboardBreadcrumbs = {
  accountSettings: {
    label: "Account",
    link: "/account",
  },
  profile: {
    label: "Profile",
    link: "/account/profile",
  },
  integrations: {
    label: "Integrations",
    link: "/account/integrations",
  },
  accountBilling: {
    label: "Subscription",
    link: "/account/subscription",
  },
  terms: {
    label: "Terms of service",
    link: TERMS_OF_SERVICE_AND_PRIVACY_POLICY_URL,
  },
  settings: {
    label: "Settings",
    link: "/account/settings",
  },
  learningCenter: {
    label: "Learning Center",
    link: "/help/learning-center",
  },
};
